import React, { createContext, useContext, useEffect, useState } from "react";
import { LANGS } from "../i18n/translations";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const stored = typeof window !== "undefined" ? localStorage.getItem("abril.lang") : null;
    return stored && LANGS.includes(stored) ? stored : "es";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      localStorage.setItem("abril.lang", lang);
      document.documentElement.setAttribute("lang", lang);
    }
  }, [lang]);

  return <LanguageContext.Provider value={{ lang, setLang }}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used inside LanguageProvider");
  return ctx;
}
